import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contentLoaded, postTestResults, setCurrentElement, setItemView } from '../../actions/index';
import VideoPlayer from '../VideoPlayer';
import {
    Link
} from 'react-router-dom';
import $ from 'jquery';
import { closeNavBar } from "../../actions/index";
import FrameContent from "../../components/frame/FrameContent";
import './ChapterContent.css';
import { SEND } from "../../utilities/const";
import Feedback from "../../components/Feedback";
import IconButton from '@material-ui/core/IconButton';
import HelpOutline from '@material-ui/icons/HelpOutline';
import {postStudentSubmission} from "../../api/post_apis";
import 'froala-editor/js/froala_editor.pkgd.min.js';

import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

import FroalaEditor from 'react-froala-wysiwyg';
import Button from "@material-ui/core/Button";
import Accordion from "@material-ui/core/Accordion";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

class ChapterContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showContent: false,
            content: null,
            loading: true,
            showFrame: false,
            itemId: '',
            nodeId: '',
            courseId: '',
            showFeedback: false,
            online: true,
            itemPk: '',
            model: '',
            disabledButton: false,
            file: ''
        }
    }

    componentDidMount() {
        setInterval(() => {
            let isOnline = window.navigator.onLine;
            if (isOnline) {
                this.setState({ online: true })
            } else {
                this.setState({ online: false })
            }

        }, 5000);
    }


    componentDidUpdate(prevProps) {
        if (this.props.active_item.item_exec_file !== prevProps.active_item.item_exec_file) {
            if (this.props.active_item &&
                this.props.active_item.item_exec_file &&
                this.props.active_item.item_exec_file.includes(".mp4")) {
                let itemId, nodeId;
                const { course_pk, item_id, node_id } = this.props.path;
                if (!item_id && !node_id) {
                    itemId = this.props.allElements[0].item_id;
                    nodeId = this.props.allElements[0].nodeId;
                } else if (!item_id) {
                    nodeId = this.props.path.node_id;
                    itemId = this.props.active_item.item_id;
                } else {
                    itemId = item_id;
                    nodeId = node_id;
                }
                // this.setState({})
                this.props.onItemView({
                    courseID: course_pk,
                    nodeID: nodeId,
                    itemID: itemId
                });
            }

        }
    }

    config = {
        placeholderText: 'Edit Your Content Here!',
        charCounterCount: false,
        key: 'Ja2A4wB2D3A1G2D4B3nA-31vzyC-11D2ri1gC7B7D6B4E4F3C1I3I2C4=='
    }

    handleModelChange = model => {
        this.setState({
            model: model
        });
        console.log(this.state.model)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { course_pk, item_id, node_id } = this.props.path;
        let questions = $("input[type='text'][name='question']");
        let data = {};

        for (let i = 0; i < questions.length; i++) {
            let selected_answer = $("input[type='radio'][name='" + questions[i].defaultValue + "']:checked");
            let result_value;
            let mc_ans = [];
            if (selected_answer.length === 0) {
                selected_answer = $("input[type='checkbox'][name='" + questions[i].defaultValue + "']:checked");
                for (let i = 0; i < selected_answer.length; i++) {
                    mc_ans.push(selected_answer[i].value);
                }
                result_value = mc_ans;
            } else {
                result_value = selected_answer[0].value
            }
            data[questions[i].defaultValue] = result_value;
        }

        this.props.postTestResults(data);
        this.props.onItemView({
            courseID: course_pk,
            nodeID: node_id,
            itemID: item_id
        });

    };


    render() {
        let item = this.props.active_item.item_exec_file;
        let newLink = this.props.active_item.item_exec_file;


        let items = [];
        if (this.props.chapter !== null && this.props.chapter.items !== undefined) {
            items = this.props.chapter.items;
        }


        let items_mapped = items.map((item, index) => {
            let btn_class = "";
            let buttonSrc = "";
            switch (item.content_type) {
                case 1:
                    if (item.item_id === parseInt(this.props.path.item_id) || (!this.props.path.item_id && index === 0)) {
                        buttonSrc = require('../../assets/img/buttons/text_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/text_inactive.png');
                    }
                    break;
                case 2:
                    if (item.item_id === parseInt(this.props.path.item_id) || !this.props.path.item_id && index === 0) {
                        buttonSrc = require('../../assets/img/buttons/video_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/video_inactive.png');
                    }
                    break;
                case 3:
                    if (item.item_id === parseInt(this.props.path.item_id) || !this.props.path.item_id && index === 0) {
                        buttonSrc = require('../../assets/img/buttons/text_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/text_active.png');
                    }
                    break;
                case 4:
                    if (item.item_id === parseInt(this.props.path.item_id) || !this.props.path.item_id && index === 0) {
                        buttonSrc = require('../../assets/img/buttons/test_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/test_inactive.png');
                    }
                    break;
                case 5:
                    if (item.item_id === parseInt(this.props.path.item_id) || !this.props.path.item_id && index === 0) {
                        buttonSrc = require('../../assets/img/buttons/problem_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/problem_inactive.png');
                    }
                    break;
                case 6:
                    if (item.item_id === parseInt(this.props.path.item_id) || (!this.props.path.item_id && index === 0)) {
                        buttonSrc = require('../../assets/img/buttons/question_active.png');
                    } else {
                        buttonSrc = require('../../assets/img/buttons/question_inactive.png');
                    }
                    break;
            }
            return (
                <div className="item-button" key={item.item_id}
                    onClick={() => this.props.closeNavBar()}>
                    <Link
                        to={"/viewer/course/" + this.props.path["course_pk"] + "/nodes/" + item.nodeId + "/item/" + item.item_id}
                        onClick={() => {
                            this.setState({item})
                            this.props.previous(this.props.path["node_id"], item.item_id, this.props.allElements, this.props.chapterContent)
                        }}
                    >
                        <img src={buttonSrc} />
                    </Link>
                    <br />
                </div>
            );
        });

        // FOR TEST CONTENT RENDERING
        let i = 0;
        let test_content = this.props.test_content.map(
            (question) => {
                i++;
                let questionHtml = `<p>${i})</p><div>${question.question_html}</div>`
                return (
                    <div key={question.question_id}>
                        <input type="text" name="question" defaultValue={question.question_id} hidden />
                        <div style={{"display": "inline-flex"}} dangerouslySetInnerHTML={{ __html: questionHtml }}>
                            {/*{checkQuestion(question.question_html)}*/}
                            {/*{question.question_html}*/}
                        </div>
                        {
                            question.variants.map(
                                (variant) => {
                                    let ansClass = 'variant';
                                    if (this.props.test_checked.length !== 0) {
                                        let isChecked = this.props.test_checked[question.question_id][variant.id];
                                        if (isChecked)
                                            ansClass = 'correct-ans';
                                        else if (isChecked == false)
                                            ansClass = 'wrong-ans';
                                    }

                                    return (
                                        <div key={variant.id} className={ansClass}>
                                            <label>
                                                {(question.question_type === 1 &&
                                                    <input type="radio" name={question.question_id} value={variant.id}
                                                        // defaultChecked
                                                        required
                                                    />)
                                                    ||
                                                    (question.question_type === 2 &&
                                                        <input type="checkbox" name={question.question_id}
                                                            value={variant.id} />)
                                                }
                                                {/*{stripHtml(variant.html)}*/}
                                                {/*{variant.html}*/}
                                                {variant.html.length > 0 ?
                                                    stripHtml(variant.html).length > 0 ?
                                                        <span>{convertToDom(variant.html)}</span> :
                                                        getImage(variant.html)
                                                    : null
                                                }
                                            </label>
                                        </div>
                                    );
                                }
                            )
                        }
                    </div>

                )
            }
        );

        // VIDEO PLAYER CONSTANTS
        let videoJsOptions = {
            autoplay: true,
            controls: true,
            sources: [{
                src: this.props.active_item.item_exec_file,
                type: 'video/mp4'
            }]
        };
        let currentItem = {
            item_id: this.props.active_item.item_id,
            node_id: this.props.active_item.node_id,
            course_id: parseInt(this.props.path.course_pk)
        };
        let showingItem = null;
        if (this.props.active_item.length !== 0) {
            if (item && this.props.active_item.content_type === 2) {
                showingItem = (<VideoPlayer {...videoJsOptions}
                    current_item={currentItem}
                />);
            } else if (this.props.active_item.content_type === 6) {
                showingItem = (
                        <div style={{width: '100%'}}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    className="accordion-style"
                                    expandIcon={<ExpandMoreIcon style={{color: 'white'}}/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Задание:</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography style={{width: '100%'}}>
                                        <FrameContent
                                            link={newLink}
                                            show={this.state.showFrame}
                                            task={true}
                                            id="frameContent"
                                            ref="frame_content"
                                            onLoader={this.childFrameLoaded}
                                        />
                                        {this.props.active_item.item_submission_file &&
                                            <p>Файл: <a target='_blank'
                                                    href={this.props.active_item.item_submission_file}>Скачать</a></p>
                                        }
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    className="accordion-style-2"
                                    expandIcon={<ExpandMoreIcon style={{color: 'white'}}/>}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography>Ваш ответ:</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography style={{width: '100%'}}>
                                        <div className="editor-div">
                                            <p>Дайте развернутый ответ на вопрос:</p>
                                            <FroalaEditor
                                                tag='textarea'
                                                config={this.config}
                                                model={this.state.model}
                                                onModelChange={this.handleModelChange}
                                            />
                                            <p>Прикрепить файл:</p>
                                            <input type="file" id="myfile" name="myfile" onChange={this.onFileChangeHandler}/>
                                        </div>
                                        <Button color="primary" disabled={this.state.disabledButton}
                                                variant="outlined" onClick={this.doStudentSubmission}>Отправить</Button>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    )
            //     showingItem = (
            //         <div className="submission-iframe-page-content">
            //             <p>Задание:</p>
            //             <div className="frame-content">
            //                 <FrameContent
            //                     link={newLink}
            //                     show={this.state.showFrame}
            //                     id="frameContent"
            //                     ref="frame_content"
            //                     onLoader={this.childFrameLoaded}
            //                 />
            //             </div>
            //             <div className="editor-div">
            //                 <p>Ваш ответ:</p>
            //                 <FroalaEditor
            //                     tag='textarea'
            //                     config={this.config}
            //                     model={this.state.model}
            //                     onModelChange={this.handleModelChange}
            //                 />
            //                 <p>Прикрепить файл:</p>
            //                 <input type="file" id="myfile" name="myfile" onChange={this.onFileChangeHandler}/>
            //             </div>
            //             <Button disabled={this.state.disabledButton} variant="outlined" onClick={this.doStudentSubmission}>Отправить</Button>
            //         </div>
            // )
            } else if (this.props.active_item.content_type !== 4) {
                showingItem = (
                    <div className="iframe-page-content">
                        <FrameContent
                            link={newLink}
                            show={this.state.showFrame}
                            id="frameContent"
                            ref="frame_content"
                            onLoader={this.childFrameLoaded}

                        />

                    </div>
                )
            }
        } else {
            showingItem = (
                <div style={{ height: '100%', marginBottom: '1em',overflow:'auto' }}>
                    <form onSubmit={this.handleSubmit}
                        style={{
                            paddingLeft: '1em',
                            width: '100%',
                            wordWrap: 'break-word',
                            height: '60vh',
                        }}
                    >
                        {
                            test_content
                        }
                        {this.props.test_content.length !== 0 && this.props.test_checked.length === 0 &&
                            <input type="submit" value={SEND} className="sendButton" />}
                        {this.props.test_checked.length !== 0 && this.props.test_checked["result"]}
                    </form>
                </div>
            )
        }


        return (
            <div class="main-content-wrap" style={{
                height: '100%',
                padding: 0,
            }}
            >
                <Feedback
                    show={this.state.showFeedback}
                    closeFeedback={this.closeFeedback}
                    itemId={this.props.active_item.item_pk}
                />

                <div
                    className="main-content"
                >
                    {this.showTitle()}
                    <div className="item-buttons">
                        {this.renderButton(items_mapped)}
                    </div>
                    {showingItem}


                </div>
            </div>
        );
    }

    renderButton = item => {
        if (this.state.online) {
            return item;
        }

        return null;
    };

    showTitle = () => {
        let random;
        if (this.props.chapter.items) {
            random = this.props.chapter.items.filter(item => item.item_id === parseInt(this.props.path.item_id))[0];
        }
        if (this.props.chapters && this.props.chapters.chaptersList && this.props.chapters.chaptersList.length > 0 && this.props.chapters.chaptersList[0].is_admin) {
            let linkPk;
            if (this.props.active_item.item_pk) {
                linkPk = this.props.active_item.item_pk;
            } else if (random) {
                linkPk = random.item_pk;
            }
            return (
                <p className="item-title">
                    <a href={`https://mbook.kz/admin/mainapp/item/${linkPk}/change/`}>{this.props.chapter.text}</a>
                </p>
            )
        } else if (this.props.chapters && this.props.chapters.chaptersList && this.props.chapters.chaptersList.length > 0 && this.props.active_item.length !== 0){
            return (
                <div id="title-item">
                <div className="item-title">
                    {this.props.chapter.text}
                </div>
                <div id="help">

                    <IconButton onClick={e => {
                        this.setState({ showFeedback: true })
                    }}  color="inherit">
                        <HelpOutline color="primary" />
                    </IconButton>
                    <div class="primary_text"  onClick={e => {
                        this.setState({ showFeedback: true })
                    }} >
                        Сообщить об ошибке
                 </div>
                </div>
            </div>
            )
        } else {
            return (
                <div id="title-item">
                    <div className="item-title">
                        {this.props.chapter.text}
                    </div>
                    <div id="help">

                        <IconButton onClick={e => {
                            this.setState({ showFeedback: true })
                        }}  color="inherit">
                            <HelpOutline color="primary" />
                        </IconButton>
                        <div class="primary_text"  onClick={e => {
                            this.setState({ showFeedback: true })
                        }} >
                            Сообщить об ошибке
                     </div>
                    </div>
                </div>
            )
        }
    };

    childFrameLoaded = () => {
        this.setState({
            showFrame: true
        })
    };

    closeFeedback = () => {
        this.setState({ showFeedback: false })
    }

    onFileChangeHandler = (e) => {
        this.setState({
            file: e.target.files[0]
        })
    }

    doStudentSubmission = () => {
        const formData = new FormData();
        formData.append('item', this.props.active_item.item_pk );
        if (this.state.file) formData.append('submitted_file', this.state.file);
        formData.append('submitted_html', this.state.model);
        postStudentSubmission(formData).then((response) => {
            response.json().then((res) => {
                if(res['message']){
                    alert(res['message'])
                } else {
                    alert(JSON.stringify(res))
                }
                this.setState({
                    disabledButton: res['message'] === 'Success'
                })
            })
        })
    }
}


function getImage(html) {
    let str = html;
    console.log(str)
    const matches = str.match(/"(.*?)"/);
    if (matches.length > 1) {
        let elements = new DOMParser().parseFromString(str, 'text/html').getElementsByTagName("IMG")[0];
        console.log(elements)
        let classList = elements.className;
        let imageStyle = null;
        if (elements.hasAttribute('style')) {
            imageStyle = elements.getAttribute('style').replace(/;/g, ',').split(/,|:/);
        }
        let imageStyleInline = {};
        if (imageStyle) {
            for (let i = 0; i < imageStyle.length / 2; i++) {
                imageStyleInline[imageStyle[i].trim()] = imageStyle[++i].trim();
            }
        }
        return (<img src={matches[1]} style={imageStyleInline} className={classList} />);

    }
    return null;
}

function checkQuestion(question) {
    if (question.includes("<img") || question.includes("<IMG")) {
        let text = stripHtml(question);
        return (<span><span>{text}</span><br />{getImage(question)}</span>);
    } else if (question.includes("<p") || question.includes("<P")) {
        let text = stripHtml(question);
        return text
    } else {
        return <span dangerouslySetInnerHTML={{ __html: question }} />;
    }
}

function stripHtml(html) {
    let stringWithouSemicolon = html.replace(/;\s*$/, "");
    let temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = stringWithouSemicolon;
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
}


function getImageOfAnswer(html) {
    let stringWithouSemicolon = html.replace(/;\s*$/, "");
    let temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = stringWithouSemicolon;
    let newLink = "https://mbook.kz/";
    let image = temporalDivElement.getElementsByTagName('IMG')[0];
    let imageLink = image.getAttribute('src');
    if (!imageLink.includes('data:image')) {
        image.setAttribute('src', newLink + imageLink);
    }
    return temporalDivElement.innerHTML;
}

function convertToDom(html) {
    if (html.includes("img")) {
        let showingItem = getImageOfAnswer(html);
        return <p dangerouslySetInnerHTML={{ __html: showingItem }} />;
    } else if (html.includes("sup") || html.includes("sub")) {
        console.log("html", html)
        return <p dangerouslySetInnerHTML={{ __html: html }} />;
    } else if (html.includes("<p")) {
        return stripHtml(html)
    } else {
        return html;
    }
}


const mapStateToProps = state => ({
    chapters: state.chapters,
    chapterContent: state.chapterContent,
    chapter: state.active,
    active_item: state.active_item,
    test_content: state.test_content,
    test_checked: state.test_checked,
    window: state.window,
    loaded: state.loaded,
    buttonClosed: state.buttonClosed,
    allElements: state.allElements
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        postTestResults: postTestResults,
        closeNavBar: closeNavBar,
        previous: setCurrentElement,
        onContentLoaded: contentLoaded,
        onItemView: setItemView
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ChapterContent);



// WEBPACK FOOTER //
// ./src/containers/ChapterContent/ChapterContent.js